module.exports = __webpack_public_path__ + "assets/img/solar-panels-6.24ccf8b4.jpg";